import { Suspense, memo } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { Skeleton } from 'antd';
import AppRoute from '../components/routes/AppRoute';
import PrivateRoute from '../components/routes/PrivateRoute';
import { appRoutes } from '../configs/routes';
import type { IAppRouteConfig } from '../configs/routes';
import PublicRoute from '../components/routes/PublicRoute';
import Login from './auth/Login';
import AuthorityGuard from '../components/routes/AuthorityGuard';
import ActiveMenuGuard from '../components/routes/ActiveMenuGuard';

function AllRoutes() {
  return (
    <Routes>
      <Route path="/" element={<PrivateRoute />}>
        {appRoutes.map((route: IAppRouteConfig) => {
          return (
            <Route
              key={route.key}
              path={route.path}
              element={
                <AuthorityGuard authority={route?.authority}>
                  <ActiveMenuGuard>
                    <AppRoute component={route.component} />
                  </ActiveMenuGuard>
                </AuthorityGuard>
              }
            />
          );
        })}
        <Route path="*" element={<Navigate to="/error-not-found" replace />} />
      </Route>
      <Route path="/" element={<PublicRoute />}>
        <Route path="/sign-in" element={<Login />} />
        {/* {publicRoutes.map((route: IAppRouteConfig) => {
          return (
            <Route
              key={route.key}
              path={route.path}
              element={<AppRoute component={route.component} />}
            />
          );
        })} */}
      </Route>
    </Routes>
  );
}

function Views(props: any) {
  return (
    <Suspense
      fallback={
        <div>
          <Skeleton
            className="bg-white dark:bg-[#0A0A0A] p-10"
            active
            paragraph={{ rows: 30 }}
          />
        </div>
      }
    >
      <AllRoutes {...props} />
    </Suspense>
  );
}

export default memo(Views);
